import Shimmer from "./Shimmer";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";

function ShimmerList({ cards }) {
	const shimmerArray = Array(cards).fill(0);
	return (
		<Container fluid>
			<Row>
				{shimmerArray.map((card, index) => {
					return (
						<Col
							xs={6}
							sm={4}
							md={3}
							lg={3}
							xl={2}
							xxl={2}
							key={index}
						>
							<Shimmer />
						</Col>
					);
				})}
			</Row>
		</Container>
	);
}
export default ShimmerList;
